import { useState, useEffect } from "react";
import { useCartData } from "@/zustand/cartStore.js";
import { useProductData } from "@/zustand/productStore.js";

import styles from "./PremiumShippingUpsell.module.scss";

import shippingIcon from "@assets/icons/shipping-icon.svg";
import discountIcon from "@assets/icons/discount-icon.svg";
import collapseIcon from "@assets/icons/collapse-icon.svg";

function PremiumShippingUpsell() {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isMobileLayout, setIsMobileLayout] = useState(false);

  const { premiumShippingUpsellEnabled, setPremiumShippingUpsellEnabled, setSelectedProduct, selectedProduct } =
    useCartData();
  const { products } = useProductData();

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileLayout(window.innerWidth <= 992);
    };

    checkScreenSize();

    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const toggleSwitch = () => {
    const isEnabled = !premiumShippingUpsellEnabled;
    setPremiumShippingUpsellEnabled(isEnabled);

    // Find the original product to get the base shipping price
    const originalProduct = products?.find((p) => p.amount === selectedProduct.amount);
    // Parse it as float, fallback to 9.95 if missing
    const baseShipping = originalProduct ? parseFloat(originalProduct.shipping_price) : 9.95;

    if (isEnabled) {
      setSelectedProduct({
        ...selectedProduct,
        shipping_price: (baseShipping + 12.95).toFixed(2),
      });
    } else {
      if (originalProduct) {
        setSelectedProduct({
          ...selectedProduct,
          shipping_price: originalProduct.shipping_price,
        });
      }
    }
  };

  return (
    <section className={styles.upsell}>
      <h4 className={styles.heading}>You May Also Like</h4>

      <div className={styles.card}>
        <label className={styles.option}>
          <div className={styles.iconRow}>
            <input type="checkbox" className={styles.checkbox} aria-label="Premium Shipping" onClick={toggleSwitch} />
            <div className={styles.iconBox}>
              <img src={shippingIcon} alt="" className={styles.shippingIcon} />
            </div>
          </div>
          {/* Desktop  */}
          {!isMobileLayout && (
            <>
              <div className={styles.labelColumn}>
                <span className={styles.labelText}>Premium Shipping</span>
              </div>
              <div className={styles.divider} />

              <div className={styles.discountColumn}>
                <div className={styles.discountBadge}>
                  <img src={discountIcon} alt="" className={styles.discountIcon} />
                  <span className={styles.discountText}>-75%</span>
                </div>
              </div>
              <div className={styles.divider} />
            </>
          )}
          {/* End Desktop  */}
          {/* Mobile  */}
          {isMobileLayout && (
            <>
              <div className={styles.discountColumn}>
                <div className={styles.labelColumn}>
                  <span className={styles.labelText}>Premium Shipping</span>
                </div>

                <div className={styles.discountBadge}>
                  <img src={discountIcon} alt="" className={styles.discountIcon} />
                  <span className={styles.discountText}>-75%</span>
                </div>
              </div>
              <div className={styles.divider} />
            </>
          )}
          {/* End Mobile  */}
          <div className={styles.priceColumn}>
            <span className={styles.originalPrice}>$49.98</span>
            <span className={styles.discountedPrice}>
              $12<sup className={styles.cents}>.95</sup>
            </span>
          </div>
        </label>

        <div className={styles.horizontalDivider} />

        <div className={styles.detailsContainer}>
          {!isCollapsed && (
            <div className={styles.detailsContent}>
              <p className={styles.detailsHeading}>
                Get the premium shipping experience and receive your order faster with a special offer today:
              </p>
              <ul className={styles.detailsList}>
                <li>Same-day order processing</li>
                <li>Priority-line shipping</li>
                <li>Parcel protection warranty</li>
              </ul>
            </div>
          )}
        </div>

        <div className={styles.collapseToggle} onClick={() => setIsCollapsed(!isCollapsed)} role="button" tabIndex={0}>
          <span>{isCollapsed ? "Show more" : "Show less"}</span>
          <img src={collapseIcon} alt="" className={isCollapsed ? styles.iconRotated : ""} />
        </div>
      </div>
    </section>
  );
}

export default PremiumShippingUpsell;
